export default "__VITE_ASSET__9a599119__"